import { styledByTheme } from "../../../../../../themes/architecture/styled-by-theme";
import {DepositSideMenuItemIconSiBox} from "./deposit-side-menu-item-icon.si.box";
import {DepositSideMenuItemIconDefaultBox} from "./deposit-side-menu-item-icon.default.box";

export const DepositSideMenuItemIconBox = styledByTheme(DepositSideMenuItemIconDefaultBox)
    .forSI(DepositSideMenuItemIconSiBox)
    .apply();
